import React from 'react';

const Paragraphs = ({ text }) => {
	if ( !text ) return null;
	
	const segments = text.split( "\n\n" ).map( (segment, index) => {
		const lines = nl2br( segment );
		return <p className="Paragraph" key={index}>{lines}</p>;
	} );

	return (
		<React.Fragment>
			{segments}
		</React.Fragment>
	)
}

const nl2br = ( text ) => {
	if ( !text ) return null;
	const segments = text.split( "\n" );
	return segments.map((item, index) => {
		const linebreak = (index < segments.length-1)? <br /> : null;
		return (
			<React.Fragment key={index}>
				<Line text={item} />{linebreak}
			</React.Fragment>
		)
	})
}

// convert [text](link) to <a />
const Line = ({ text }) => {
	const outputSegments = [];

	// positive lookahead, non-first segment will contain []() at the beginning
	const inputSegments = text.replace(/</g, '&lt;').split(/(?=\[[^\]]+\]\([^)]+\))/g);

	inputSegments.forEach((seg) => {
		// [1] is link part [](), [2] is text part
		const parts = /(\[[^\]]+\]\([^)]+\))(.*)/.exec(seg);

		if(!parts){ // text only
			outputSegments.push(<React.Fragment key={outputSegments.length}>{seg}</React.Fragment>);
		} else {
			const linkParts = parts[1].substring(1, parts[1].length - 1).split('](');
			outputSegments.push(
				<React.Fragment key={outputSegments.length}><a target="_blank" href={linkParts[1]}>{linkParts[0]}</a></React.Fragment>,
				<React.Fragment key={outputSegments.length + 1}>{parts[2]}</React.Fragment>
			);
		}
	});

	return outputSegments;
}


export default Paragraphs;


// WEBPACK FOOTER //
// ./src/components/common/Paragraphs.jsx